// @flow
export { default } from './WriteExtraTempSaveItem';



// WEBPACK FOOTER //
// ./src/components/write/WriteExtraTempSaveItem/index.js